// Feature flags API — relocated out of the removed barratt module.
// Backed by the core endpoint GET /api/v1/core/feature-flags/.
import api, { type AxiosResponse } from './client';

export interface FeatureFlags {
  delivery_appeals: boolean;
  spend_leakage: boolean;
  bulk_upload: boolean;
  commodity_codes: boolean;
  customer_stock_levels: boolean;
  switch_call_off_tab: boolean;
  allow_customer_decline: boolean;
  po_line_schedules: boolean;
  schedule_collaboration: boolean;
  show_forecast_total: boolean;
  // OTIF visibility on the Sales Orders dashboard. When false, OTIF tiles,
  // columns, drill-downs and trend lines are not rendered (OTD is unaffected).
  sales_orders_otif: boolean;
  // Certificate of Conformity / Despatch Note on order lines, generated from
  // imported ERP job records. Off by default — certified paperwork that goes
  // to a customer, so it is switched on deliberately (Admin Setup > Features).
  job_documents: boolean;
  // Portal mode set by PLATFORM_MODE env var or Admin Setup > Features
  portal_mode?: 'standard' | 'compliance' | 'supplier_portal';
  // Dashboard tab visibility (CR-4441)
  dashboard_tabs?: Record<string, boolean>;
  customer_dashboard_tabs?: Record<string, boolean>;
}

export const featureFlagsAPI = {
  getFeatureFlags: (): Promise<AxiosResponse<FeatureFlags>> =>
    api.get('/core/feature-flags/'),
};
